<template>
  <svg
    width="14px"
    height="8px"
    viewBox="0 0 14 8"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>56586D35-7705-4CC2-8B91-D1C0FEAE59FB</title>
    <g id="Desk" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="3.-Informações-do-estabelecimento"
        transform="translate(-1530.000000, -519.000000)"
        stroke="#686361"
      >
        <polyline
          id="seta-select"
          points="1530 520.129152 1536.51557 526.129051 1543.21314 520.129152"
        ></polyline>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "OpenIndicator",
};
</script>
